export default {
	routes: {
		home: {
			path: '/',
			name: 'home',
			isTransparentBackground: true,
			isWithoutMainDistance: true,
			isBlackBackground: true,
		},

		termsAndConditions: {
			path: '/terms-and-conditions/',
			name: 'termsAndConditions',
		},

		notFound: {
			path: '/not-found/',
			name: 'notFound',
		},

		uiKit: {
			path: '/ui-kit/',
			name: 'uiKit',
		},

		//! Header Global
		discoverArmenia: {
			name: 'discoverArmenia',
			isHeader: {
				desktop: true,
				mobile: true,
			},
			dropdown: true,
		},

		businessEnvironment: {
			name: 'businessEnvironment',
			isHeader: {
				desktop: true,
				mobile: true,
			},
			dropdown: true,
		},

		sectors: {
			name: 'sectors',
			path: '/sectors/',
			isHeader: {
				desktop: true,
				mobile: true,
			},
			dropdown: true,
		},

		company: {
			name: 'company',
			dropdown: true,
		},

		media: {
			name: 'media',
			isHeader: {
				desktop: true,
				mobile: true,
			},
			dropdown: true,
		},

		services: {
			path: '/services/',
			name: 'services',
			isHeader: {
				desktop: true,
				mobile: true,
			},
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		contactUs: {
			path: '/contact-us/',
			name: 'contactUs',
			isHeader: {
				desktop: false,
				mobile: true,
			},
		},

		//! Discover Armenia Menus
		whyArmenia: {
			path: '/discover-armenia/why-armenia/',
			name: 'whyArmenia',
			isDiscoverArmeniaHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		livingInArmenia: {
			path: '/discover-armenia/living-in-armenia/',
			name: 'livingInArmenia',
			isDiscoverArmeniaHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		successStories: {
			path: '/discover-armenia/success-stories/',
			name: 'successStories',
			// isDiscoverArmeniaHeaderMenu: true,
		},

		benchmark: {
			path: '/discover-armenia/benchmark/',
			name: 'benchmark',
			// isDiscoverArmeniaHeaderMenu: true,
			isWithoutMainDistance: true,
			isTransparentBackground: true,
		},

		//! Business Environment Menus
		businessRegistration: {
			path: '/business-environment/business-registration/',
			name: 'businessRegistration',
			isBusinessEnvironmentHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		taxationSystem: {
			path: '/business-environment/taxation-system/',
			name: 'taxationSystem',
			isBusinessEnvironmentHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		investmentLegislation: {
			path: '/business-environment/investment-legislation/',
			name: 'investmentLegislation',
			isBusinessEnvironmentHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		marketAndForeignTrade: {
			path: '/business-environment/market-and-foreign-trade/',
			name: 'marketAndForeignTrade',
			isBusinessEnvironmentHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		macroeconomicIndicators: {
			path: '/business-environment/macroeconomic-indicators/',
			name: 'macroeconomicIndicators',
			isBusinessEnvironmentHeaderMenu: true,
			isTransparentBackground: true,
			isWithoutMainDistance: true,
		},

		incentives: {
			path: '/business-environment/incentives/tax-and-customs-incentive/',
			name: 'incentives',
			isBusinessEnvironmentHeaderMenu: true,
			// Keep header item active on all Incentives detail pages
			activeBasePath: '/business-environment/incentives/',
			keepActiveOnIndividuals: true,
		},

		//! Company Menus
		aboutUs: {
			path: '/company/about-us/',
			name: 'aboutUs',
			isCompanyHeaderMenu: true,
			isWithoutMainDistance: true,
			isTransparentBackground: true,
			isFooter: true,
			isBlackBackground: true,
		},

		ourTeam: {
			path: '/company/our-team/',
			name: 'ourTeam',
			isCompanyHeaderMenu: true,
			isFooter: true,
		},

		boardOfTrustees: {
			path: '/company/board-of-trustees/',
			name: 'boardOfTrustees',
			isCompanyHeaderMenu: true,
			isFooter: true,
		},

		networkOfRepresentatives: {
			path: '/company/network-of-representatives/',
			name: 'networkOfRepresentatives',
			isCompanyHeaderMenu: true,
			isFooter: true,
		},

		career: {
			path: '/company/career/',
			name: 'career',
			isCompanyHeaderMenu: true,
			isFooter: true,
		},

		//! Media & Events Menus
		news: {
			path: '/media/news/',
			name: 'news',
			isMediaHeaderMenu: true,
		},

		publications: {
			path: '/media/publications/',
			name: 'publications',
			isMediaHeaderMenu: true,
		},

		events: {
			path: '/media/events/',
			name: 'events',
			// isMediaHeaderMenu: true,
		},

		search: {
			path: '/search/',
			name: 'search',
		},
	},
};
